import { act_awd } from '@lc/action/cardType/Award';
import { act_com } from '@lc/action/cardType/Common';
// import { AwardMeta } from '@lc/card/meta/fw/AwardMeta';
import { createCardAwardVerbose } from '@lc/interface/card/award/factory';
import { Award } from '@lc/interface/card/award/types';
import { GameState } from '@lc/interface/gameState/types';

export const getAwardVerbose = (AwardMeta: Award[]) => [
	createCardAwardVerbose(
		AwardMeta[0],
		(
			playerData: any,
			gameState: GameState // 100
		) => act_awd.rAndD(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 100
		) => act_awd.rAndD(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[1],
		(
			playerData: any,
			gameState: GameState // 101
		) => act_awd.dasExhausting(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 101
		) => act_awd.dasExhausting(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[2],
		(
			playerData: any,
			gameState: GameState // 102
		) => act_awd.costmetics(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 102
		) => act_awd.costmetics(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[3],
		(
			playerData: any,
			gameState: GameState // 103
		) => act_awd.foamFinger(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 103
		) => act_awd.foamFinger(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[4],
		(
			playerData: any,
			gameState: GameState // 104
		) => act_awd.industrialist(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 104
		) => act_awd.industrialist(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[5],
		(
			playerData: any,
			gameState: GameState // 105
		) => act_awd.gov1(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 105
		) => act_awd.gov1(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[6],
		(
			playerData: any,
			gameState: GameState // 106
		) => act_awd.gov2(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 106
		) => act_awd.gov2(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[7],
		(
			playerData: any,
			gameState: GameState // 107
		) => act_awd.eCigs(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 107
		) => act_awd.eCigs(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[8],
		(
			playerData: any,
			gameState: GameState // 108 no energy left behind
		) => act_awd.noEnergyLeftBehind(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 108 no energy left behind
		) => act_awd.noEnergyLeftBehind(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[9],
		(
			playerData: any,
			gameState: GameState // 109
		) => act_awd.electricFence(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 109
		) => act_awd.electricFence(playerData, gameState)
	),
	createCardAwardVerbose(
		// 110 Ferverent Filibuster. Can we choose a distribute or just dump all on someone?
		AwardMeta[10],
		(
			playerData: any,
			gameState: GameState // TODO
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[11],
		(
			playerData: any,
			gameState: GameState // 111
		) => act_awd.keepingCurrent(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 111
		) => act_awd.keepingCurrent(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[12],
		(
			playerData: any,
			gameState: GameState // 112
		) => act_awd.bestManagement(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 112
		) => act_awd.bestManagement(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[13],
		(
			playerData: any,
			gameState: GameState // 113
		) => act_awd.nepotism(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 113
		) => act_awd.nepotism(playerData, gameState)
	),
	createCardAwardVerbose(
		AwardMeta[14],
		(
			playerData: any,
			gameState: GameState // 114
		) => act_awd.blackFriday(playerData, gameState, true),
		() => {},
		(
			playerData: any,
			gameState: GameState // 114
		) => act_awd.blackFriday(playerData, gameState)
	),
	createCardAwardVerbose(
		// 115
		AwardMeta[15],
		(playerData: any, gameState: GameState) =>
			act_awd.giveNeighborsCF(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.setTargetArrToNeighbors(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.highestCarbonFootprint(playerData, gameState)
	),
	createCardAwardVerbose(
		// 116
		AwardMeta[16],
		(playerData: any, gameState: GameState) =>
			act_awd.stealSummitCard(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.setTargetArrToNeighbors(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_awd.lowestPR(playerData, gameState)
	),
];
